<div class="variant-snackbar">
    <div class="variant-snackbar-container">
        <div class="message">
            {{ variantsCount }} variants has been removed.
        </div>
        <div (click)="undoDeleteVariants()" class="variant-undo">Undo</div>
        <mat-icon
            class="variant-snackbar-close"
            (click)="closeDeleteAlertSnackBar()"
            >close</mat-icon
        >
    </div>
</div>
